import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const BCIndustryGroup = React.lazy(() =>
    import('../BCIndustryGroup')
);
const bCIndustryGroupRoutesRegistry = [
    {
        path: PAGE_URL.B_C_INDUSTRY_GROUP_PAGE,
        element: <BCIndustryGroup />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default bCIndustryGroupRoutesRegistry;
